import { Card, CardProps } from '@mui/material'
import { motion } from 'motion/react'
import { EnterPreset, useMotionPreset, ExitPreset } from './Motion/animationPresets'

interface CardContainerProps extends CardProps {
  layout?: boolean
  entering?: EnterPreset | EnterPreset[]
  exiting?: ExitPreset | ExitPreset[]
}

const CardContainer = (props: CardContainerProps) => {
  const { sx, layout, entering, exiting, ...rest } = props

  return <Card
    elevation={0}
    sx={{
      p: 1,
      '& .MuiCardActions-root': { pt: 0 },
      '& .MuiListItemButton-root': { mr: -1, ml: -1, pr: 4, pl: 4, pt: 2, pb: 2 }, 
      '& .MuiDivider-root': { ml: -1, mr: -1 },
      '& .MuiList-root': { pt: 0, pb: 0 },
      '& .MuiCardContent-root:last-child': { pb: 3 },
      border: '1px solid',
      borderColor: 'background.default',
      width: '100%',
      ...sx,
    }}
    component={motion.div}
    layout={layout}
    {...useMotionPreset({ entering, exiting })}
    {...rest}
  >
    {props.children}
  </Card>
}

export default CardContainer
